<template lang="html">
  <v-menu offset-y class="mr-2">
    <template v-slot:activator="{ on }">
    <v-card class="pr-0 pl-1 dropdown-width" v-on="on" style="border-radius: 5px;" :color="`${color}`">
      <v-layout align-center>
      <v-icon v-if="icon" class="dataFieldIcon" color="black">{{icon}}</v-icon>
      <div :style="`color: ${textcolor}; cursor: pointer`">{{value}}</div>
      <v-icon>keyboard_arrow_down</v-icon>
      </v-layout>
    </v-card>
  </template>
  <v-card class="pr-2 pl-2 options-scroll" style="border-radius: 5px;" :color="`${color}`">
    <div
      class="options"
      v-for="(option, index) in options"
      @click="$emit('changeValue', option)"
      :key="index"
      >
      <template v-if="option.name === 'Other'">
        <v-icon color="primary">flag</v-icon>
      </template>
      <template v-else>
        <country-flag :country='option.flag' class="mr-1" />
      </template>
      {{option.name}}
    </div>
  </v-card>
  </v-menu>
</template>

<script>
import CountryFlag from 'vue-country-flag'
export default {
  components: {
    CountryFlag
  },
  props: ['icon', 'value', 'placeholder', 'color', 'readonly', 'textcolor', 'options'],
  methods: {
  }
}
</script>

<style lang="css" scoped>
  .dropdown-width {
    max-width: 100%;
  }
  .options-scroll {
    overflow-y: scroll;
    max-height: 500px;
    max-width: 100%;
  }
  .options {
    cursor: pointer;
  }
  /* .options:hover {
    background-color: grey;
  } */
  .work_package-data-field {
    color: black;
    width: 100%;
    font-size: 20px;
    /* border-bottom: solid;
    border-width: 1px; */
    /* background-color: white;
    opacity: 0.25; */
  }
  .work_package-data-field::placeholder {
    color: black;
    font-style: italic;
    /* background-color: white;
    opacity: 0.25; */
  }
  .dataFieldIcon {
    zoom: 1.2;
  }

  .work_package-data-field:focus {
       width: 100%;
       outline: none;
  }
</style>
